var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'tsyringe';
import firebase from 'firebase/app';
let FirestoreDataSource = class FirestoreDataSource {
    async loadDocuments(input) {
        const collection = this.query(input);
        const snapshots = await collection.get({ source: input.source !== undefined ? input.source : 'default' });
        console.log(snapshots.docs);
        if (snapshots.empty) {
            return {
                isEmpty: true,
                docs: [],
            };
        }
        return {
            isEmpty: false,
            docs: snapshots.docs,
            lastDocument: snapshots.docs.slice(-1)[0],
        };
    }
    query(input) {
        let collection = this.getCollection(input.isGroup, input.path);
        collection = collection.limit(input.limit);
        if (input.orderBy !== undefined) {
            collection = collection.orderBy(input.orderBy.fieldPath, input.orderBy.directionStr);
        }
        if (input.whereList !== undefined) {
            for (const item of input.whereList) {
                collection = collection.where(item.fieldPath, item.opStr, item.value);
            }
        }
        if (input.startAfter !== undefined) {
            collection = collection.startAfter(input.startAfter);
        }
        if (input.startAt !== undefined) {
            collection = collection.startAt(input.startAt);
        }
        if (input.endBefore !== undefined) {
            collection = collection.endBefore(input.endBefore);
        }
        if (input.endAt !== undefined) {
            collection = collection.endAt(input.endAt);
        }
        return collection;
    }
    getCollection(isGroup, path) {
        if (isGroup) {
            return firebase.firestore().collectionGroup(path);
        }
        else {
            return firebase.firestore().collection(path);
        }
    }
};
FirestoreDataSource = __decorate([
    injectable()
], FirestoreDataSource);
export { FirestoreDataSource };
